import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { GridToolbarContainer, useGridApiContext } from "@mui/x-data-grid-premium";
import BryxBox from "../BryxBox";
import BryxButton from "../BryxButton";
import BryxIcon from "../BryxIcon/BryxIcon";
import BryxPopper from "../BryxPopper";
import BryxTBD from "../BryxTBD";
import { BryxDataGridFilterPanel } from "./BryxDataGridFilterPanel";
export const BryxDataGridToolbar = ({ tableOptionsComponent, bulkToggleAction, onBulkExport, onBulkArchive, isHidden, setIsHidden, isExportDisabled = () => false, isArchiveDisabled = () => false, }) => {
    const apiRef = useGridApiContext();
    const selectedRowMap = apiRef.current.getSelectedRows();
    const selectedRows = Array.from(selectedRowMap.values());
    const onExport = () => {
        if (selectedRows.length > 0) {
            onBulkExport?.(selectedRows);
        }
    };
    const onArchive = () => {
        if (selectedRows.length > 0) {
            onBulkArchive?.(selectedRows);
        }
    };
    return (_jsx(GridToolbarContainer, { children: _jsx(BryxBox, { isFlex: true, fullWidth: true, sx: {
                borderBottom: 1,
                borderColor: "divider",
                flexDirection: "row",
                justifyContent: "left",
                marginLeft: "-28px",
                marginRight: "-54px",
                marginBottom: "24px",
                height: "40px",
                width: "stretch",
                paddingLeft: "48px",
            }, children: _jsx(BryxTBD, { visible: _jsxs(_Fragment, { children: [_jsx(BryxPopper, { icon: "filter_list", label: "Filter", defaultOpen: false, children: _jsx(BryxDataGridFilterPanel, {}) }), _jsx(BryxPopper, { icon: "list", label: "Table Options", defaultOpen: false, children: tableOptionsComponent })] }), hidden: _jsxs(_Fragment, { children: [_jsx(BryxButton, { startIcon: _jsx(BryxIcon, { iconName: "share", smIconSize: true }), onClick: () => onExport(), disabled: isExportDisabled() || selectedRows.length < 1, children: "Bulk Export" }), _jsx(BryxButton, { startIcon: _jsx(BryxIcon, { iconName: "delete", smIconSize: true }), onClick: () => onArchive(), disabled: isArchiveDisabled() || selectedRows.length < 1, children: "Bulk Archive" })] }), toggleIcon: "dynamic_feed", toggleName: "Bulk Actions", isHidden: isHidden, setIsHidden: setIsHidden, toggleAction: bulkToggleAction }) }) }));
};
export default BryxDataGridToolbar;
